import { useEffect, useRef, useState } from 'react';

const KEY = 'tla.experience.navhistory';
const MAX = 20;

function load() {
  try {
    const raw = sessionStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
}

function save(stack) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(stack.slice(-MAX)));
  } catch (e) {
    /* sessionStorage unavailable (private mode / SSR): degrade to in-memory only */
  }
}

// Records { path, label, ts } on each distinct in-app navigation. sessionStorage-backed so
// it survives in-tab route changes but resets per tab: a cold entry (deep link / new tab)
// starts empty, which is exactly what lets the flow model fall back Parent -> dashboard.
export function useNavigationHistory(pathname, label) {
  const [stack, setStack] = useState(load);
  const lastPath = useRef(null);

  useEffect(() => {
    if (!pathname) return;
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    setStack((prev) => {
      const top = prev[prev.length - 1];
      if (top && top.path === pathname) return prev;
      const next = [...prev, { path: pathname, label, ts: Date.now() }].slice(-MAX);
      save(next);
      return next;
    });
  }, [pathname, label]);

  return stack;
}
